<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1" id="copyright"><a id="page_4"></a>Copyright © 2015 by Kimberly A. Tessmer, RDN, LD</p>
<p class="copyi">All rights reserved under the Pan-American and International Copyright Conventions. This book may not be reproduced, in whole or in part, in any form or by any means electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system now known or hereafter invented, without written permission from the publisher, The Career Press.</p>
<p class="copy1">Y<span class="small">OUR</span> N<span class="small">UTRITION</span> S<span class="small">OLUTION TO A</span> H<span class="small">EALTHY</span> G<span class="small">UT</span></p>
<p class="copy">E<span class="small">DITED BY</span> K<span class="small">IRSTEN</span> D<span class="small">ALLEY</span></p>
<p class="copy">Cover design by Joanna Williams</p>
<p class="copy">Printed in the U.S.A.</p>
<p class="copyi">To order this title, please call toll-free 1-800-CAREER-1 (NJ and Canada: 201-848-0310) to order using VISA or MasterCard, or for further infor-mation on books from Career Press.</p>
<p class="copya"><img alt="Images" height="77" src="images/pub1.jpg" width="274"/></p>
<p class="copy">The Career Press, Inc.</p>
<p class="copy">220 West Parkway, Unit 12</p>
<p class="copy">Pompton Plains, NJ 07444</p>
<p class="copy"><a href="http://www.careerpress.com" target="_blank">www.careerpress.com</a></p>
<p class="copy"><a href="http://www.newpagebooks.com" target="_blank">www.newpagebooks.com</a></p>
<p class="copy2"><strong>Library of Congress Cataloging-in-Publication Data</strong></p>
<p class="copyn">Tessmer, Kimberly A.</p>
<p class="copyind">Your nutrition solution to a healthy gut : a meal-based plan to help prevent and treat constipation, diverticulitis, ulcers, and other common digestive problems / by Kimberly Tessmer, RDN, LD.</p>
<p class="copyind1">pages cm</p>
<p class="copyind">Includes bibliographical references and index.</p>
<p class="copyind">ISBN 978-1-60163-368-2 (paperback) -- ISBN 978-1-60163-384-2 (ebook) 1. Gastrointestinal system--Diseases--Nutritional aspects-Popular works. 2. Gastrointestinal system--Diseases--Diet therapy-Recipes. I. Title.</p>
<p class="copyind">RC806.T47 2015</p>
<p class="copyind">616.3’30654--dc23</p>
<p class="copyr">2015010093</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?3305a3a8